<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre_25" id="filepos76212"><span class="calibre10"><span class="italic1">9 <img alt="image" class="calibre11" src="images/00004.jpg"/> Free-will - I</span></span></h2><div class="calibre_14"> </div>
<p class="calibre_18"><span class="calibre5">Our sole freedom is the faculty of understanding, for there is only one mind, and nothing else is. (The T’ang Masters have been quoted to this effect, especially Hsi Yun.)</span></p>
<p class="calibre_19"><span class="calibre5">It follows that our only liberty of “action” lies in the exercise of this faculty, and the resulting change in our apparent selves.</span></p>
<p class="calibre_19"><span class="calibre5">If this should appear difficult to comprehend we might do well to envisage mind as an ultimate subtlety or essence traversing all dimensions, manifesting in all, and constituting thereby a <em class="italic">liaison</em> between the densest force-field of the material world and Absolute Reality, of which it is the purest manifestation perceptible to us.</span></p>
<h3 class="calibre_26" id="filepos77296"><span class="calibre12"><span class="italic1">Free-will II</span></span></h3><div class="calibre_14"> </div>
<p class="calibre_19"><span class="calibre5">How can a figment of the imagination have any effect on anything that is not itself a figment of the imagination? Therefore any effect resulting from an act of “will” subject to the ego-concept can only be as imaginary as itself.</span></p> <div class="mbp_pagebreak" id="calibre_pb_33"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_019.vue?a81fcb7a